export var InlineCssClass;
(function (InlineCssClass) {
    InlineCssClass["Base"] = "iress-inline";
    InlineCssClass["Inner"] = "iress-inline__inner";
    InlineCssClass["NoWrap"] = "iress-inline--no-wrap";
    InlineCssClass["HorizontalAlign"] = "iress-inline__h-align";
    InlineCssClass["VerticalAlign"] = "iress-inline__v-align";
    InlineCssClass["Gutter"] = "iress-inline__gutter";
})(InlineCssClass || (InlineCssClass = {}));
export var InlineHorizontalAlign;
(function (InlineHorizontalAlign) {
    InlineHorizontalAlign["Around"] = "around";
    InlineHorizontalAlign["Between"] = "between";
    InlineHorizontalAlign["Center"] = "center";
    InlineHorizontalAlign["Evenly"] = "evenly";
    InlineHorizontalAlign["Left"] = "left";
    InlineHorizontalAlign["Right"] = "right";
})(InlineHorizontalAlign || (InlineHorizontalAlign = {}));
export var InlineVerticalAlign;
(function (InlineVerticalAlign) {
    InlineVerticalAlign["Bottom"] = "bottom";
    InlineVerticalAlign["Middle"] = "middle";
    InlineVerticalAlign["Stretch"] = "stretch";
    InlineVerticalAlign["Top"] = "top";
})(InlineVerticalAlign || (InlineVerticalAlign = {}));
export var InlineGutter;
(function (InlineGutter) {
    InlineGutter["None"] = "none";
    InlineGutter["Xs"] = "xs";
    InlineGutter["Sm"] = "sm";
    InlineGutter["Md"] = "md";
    InlineGutter["Lg"] = "lg";
    InlineGutter["Xl"] = "xl";
})(InlineGutter || (InlineGutter = {}));
//# sourceMappingURL=inline.types.js.map